(function(){"use strict";try{if(typeof document<"u"){var a=document.createElement("style");a.appendChild(document.createTextNode(".plugin-title[data-v-6de15a87]{font-size:24px;margin-bottom:20px;color:#333}.setting-collapse[data-v-6de15a87]{margin-bottom:20px}.plugin-list[data-v-6de15a87]{margin-top:20px}.plugin-card[data-v-6de15a87]{margin-bottom:16px;border:1px solid #f0f0f0;border-radius:8px;transition:all .3s}.plugin-card[data-v-6de15a87]:hover{box-shadow:0 4px 12px #00000026}.plugin-card-content[data-v-6de15a87]{display:flex;flex-direction:column;gap:16px}.plugin-info[data-v-6de15a87]{display:flex;flex-direction:column;gap:8px}.plugin-header[data-v-6de15a87]{display:flex;align-items:center;gap:12px}.plugin-icon[data-v-6de15a87]{width:48px;height:48px;display:flex;align-items:center;justify-content:center;background:#f5f5f5;border-radius:8px}.plugin-icon-image[data-v-6de15a87]{width:100%;height:100%;border-radius:8px;overflow:hidden}.plugin-icon-image img[data-v-6de15a87]{width:100%;height:100%;object-fit:cover}.plugin-icon-text[data-v-6de15a87]{font-size:24px}.plugin-meta[data-v-6de15a87]{flex:1}.plugin-name[data-v-6de15a87]{font-size:16px;font-weight:600;color:#333}.plugin-version[data-v-6de15a87]{font-size:12px;color:#999}.plugin-status[data-v-6de15a87]{margin-left:auto}.plugin-description[data-v-6de15a87]{font-size:14px;color:#666;line-height:1.5}.plugin-author[data-v-6de15a87]{font-size:12px;color:#999}.plugin-credits[data-v-6de15a87]{font-size:12px;color:var(--secondary-color);display:flex;align-items:center;margin-top:4px}.credits-value[data-v-6de15a87]{font-weight:600;margin:0 4px}.plugin-actions[data-v-6de15a87]{display:flex;gap:8px;margin-top:8px;justify-content:flex-end;width:100%}.plugin-action-btn[data-v-6de15a87]{margin-right:8px}.empty-plugins[data-v-6de15a87]{text-align:center;padding:40px;color:#999;background:#fafafa;border-radius:8px}.install-plugin-modal[data-v-6de15a87]{padding:20px 0}.setting-item[data-v-6de15a87]{margin-bottom:16px}.setting-label[data-v-6de15a87]{display:block;margin-bottom:8px;font-weight:500;color:#333}.install-tips[data-v-6de15a87]{margin-top:16px;font-size:12px;color:#999;line-height:1.5}html.dark .plugin-card[data-v-6de15a87]{border:1px solid #333;background-color:#1f1f1f}html.dark .plugin-card[data-v-6de15a87]:hover{box-shadow:0 4px 12px #ffffff1a}html.dark .plugin-name[data-v-6de15a87]{color:#fff}html.dark .plugin-description[data-v-6de15a87]{color:#ffffffd9}html.dark .plugin-author[data-v-6de15a87]{color:#ffffffa6}html.dark .empty-plugins[data-v-6de15a87]{color:#ffffffa6;background:#262626}html.dark .setting-label[data-v-6de15a87]{color:#ffffffd9}html.dark .install-tips[data-v-6de15a87]{background-color:#141414;color:#ffffffa6}")),document.head.appendChild(a)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { computed as A, ref as w, defineComponent as N, resolveComponent as g, createElementBlock as m, openBlock as u, createElementVNode as s, createVNode as p, withCtx as d, createBlock as C, unref as o, createTextVNode as _, toDisplayString as l, createCommentVNode as $, Fragment as O, renderList as T, isRef as I } from "vue";
import { pluginManager as c, PluginStatus as y } from "@gitcoffee/plugins";
import { t as r } from "@gitcoffee/i18n";
import { message as v, Modal as V } from "@gitcoffee/design-ui";
import { useAuth as j } from "@gitcoffee/auth";
const { checkLogin: k } = j(), h = w(!1), P = w(""), L = A(() => {
  if (console.log("Plugins from manager:", c.pluginsData.plugins), console.log(
    "Current pluginsData.plugins length:",
    c.pluginsData.plugins.length
  ), console.log(
    "Current pluginsData.plugins:",
    c.pluginsData.plugins
  ), !Array.isArray(c.pluginsData.plugins))
    return console.error(
      "pluginsData.plugins is not an array:",
      c.pluginsData.plugins
    ), [];
  const n = c.pluginsData.plugins.map((t, i) => (console.log(`Processing plugin data ${i}:`, t), !t || typeof t != "object" ? (console.error(`Plugin data at index ${i} is invalid:`, t), null) : !t.id || !t.metadata ? (console.error(
    `Plugin data at index ${i} is missing required fields (id or metadata):`,
    t
  ), null) : {
    ...t.metadata,
    id: t.id,
    status: t.status
  })).filter(Boolean);
  console.log("Mapped and filtered pluginItems:", n), console.log("Mapped pluginItems length:", n.length);
  const a = [...n].sort((t, i) => t?.name === "Social Media Plugin" ? -1 : i?.name === "Social Media Plugin" ? 1 : 0);
  return console.log("Final sorted pluginsList:", a), console.log("Final sorted pluginsList length:", a.length), a;
}), K = async () => {
  if (await k() && P.value.trim())
    try {
      console.log("Installing plugin from URL:", P.value), P.value = "", h.value = !1, D(), v.success(r("setting.pluginInstalled"));
    } catch (n) {
      console.error("Failed to install plugin:", n), v.error(r("setting.pluginInstallFailed"));
    }
}, D = async () => {
  await k() && console.log("Refreshing plugins...");
}, q = async (n) => {
  if (await k())
    try {
      const a = c.pluginsData.plugins.find(
        (i) => i.id === n
      );
      if (!a) {
        console.error("Plugin data not found for pluginId:", n);
        return;
      }
      const t = a.metadata.credits || 0;
      if (t > 0)
        try {
          await V.confirm({
            title: r("setting.plugin.activate.confirmTitle"),
            content: r("setting.plugin.activate.confirmContent", {
              requiredCredits: t
            }),
            okText: r("setting.plugin.activate.confirmOk"),
            cancelText: r("setting.plugin.activate.confirmCancel")
          });
        } catch {
          return;
        }
      await c.activatePlugin(n), t > 0 ? v.success(
        r("setting.plugin.activate.successWithCredits", { requiredCredits: t })
      ) : v.success(r("setting.plugin.activate.success"));
    } catch (a) {
      console.error("Failed to activate plugin:", a), v.error(r("setting.plugin.activate.failed"));
    }
}, z = async (n) => {
  if (await k())
    try {
      await c.deactivatePlugin(n);
    } catch (a) {
      console.error("Failed to deactivate plugin:", a), v.error(r("setting.plugin.deactivate.failed"));
    }
}, W = async (n) => {
  if (await k())
    try {
      await c.uninstallPlugin(n);
    } catch (a) {
      console.error("Failed to uninstall plugin:", a), v.error(r("setting.plugin.uninstall.failed"));
    }
}, G = async () => {
  await k() && (h.value = !0);
}, H = (n) => /^https?:\/\//i.test(n) && /\.(png|jpg|jpeg|gif|svg)$/i.test(n), J = (n) => {
  switch (n) {
    case y.ENABLED:
      return "success";
    case y.DISABLED:
      return "default";
    case y.ERROR:
      return "error";
    default:
      return "processing";
  }
}, Q = (n) => {
  switch (n) {
    case y.ENABLED:
      return r("setting.enabled");
    case y.DISABLED:
      return r("setting.disabled");
    case y.ERROR:
      return r("setting.error");
    default:
      return r("setting.installed");
  }
}, X = { class: "plugin-container" }, Y = { class: "plugin-content" }, Z = { class: "setting-item" }, x = { class: "plugin-actions" }, tt = { class: "plugin-list" }, et = { class: "plugin-card-content" }, nt = { class: "plugin-info" }, st = { class: "plugin-header" }, it = {
  key: 0,
  class: "plugin-icon"
}, lt = {
  key: 0,
  class: "plugin-icon-image"
}, at = ["src", "alt"], ot = {
  key: 1,
  class: "plugin-icon-text"
}, rt = { class: "plugin-meta" }, ct = { class: "plugin-name" }, ut = { class: "plugin-version" }, dt = { class: "plugin-status" }, gt = { class: "plugin-description" }, pt = { class: "plugin-author" }, _t = {
  key: 0,
  class: "plugin-credits"
}, ft = { class: "credits-value" }, mt = { class: "plugin-actions" }, vt = {
  key: 0,
  class: "empty-plugins"
}, ht = { class: "install-plugin-modal" }, yt = { class: "setting-item" }, Pt = { class: "setting-label" }, kt = { class: "install-tips" }, Ct = /* @__PURE__ */ N({
  __name: "Plugin",
  setup(n) {
    const a = w(["plugins"]);
    return (t, i) => {
      const f = g("a-button"), E = g("a-tag"), M = g("a-card"), R = g("a-collapse-panel"), U = g("a-collapse"), B = g("a-space"), F = g("a-input"), S = g("a-modal");
      return u(), m("div", X, [
        s("div", Y, [
          p(B, {
            direction: "vertical",
            size: 16,
            style: { width: "100%" }
          }, {
            default: d(() => [
              p(U, {
                activeKey: a.value,
                "onUpdate:activeKey": i[0] || (i[0] = (e) => a.value = e),
                class: "setting-collapse"
              }, {
                default: d(() => [
                  (u(), C(R, {
                    key: "plugins",
                    header: t.$t("setting.plugins")
                  }, {
                    default: d(() => [
                      s("div", Z, [
                        s("div", x, [
                          p(f, {
                            type: "primary",
                            onClick: o(G)
                          }, {
                            default: d(() => [
                              _(l(t.$t("setting.installPlugin")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          p(f, { onClick: o(D) }, {
                            default: d(() => [
                              _(l(t.$t("setting.refreshPlugins")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]),
                      s("div", tt, [
                        (u(!0), m(O, null, T(o(L), (e) => (u(), C(M, {
                          key: e.id,
                          bordered: !1,
                          class: "plugin-card"
                        }, {
                          default: d(() => [
                            s("div", et, [
                              s("div", nt, [
                                s("div", st, [
                                  e.icon ? (u(), m("div", it, [
                                    o(H)(e.icon) ? (u(), m("div", lt, [
                                      s("img", {
                                        src: e.icon,
                                        alt: e.name
                                      }, null, 8, at)
                                    ])) : (u(), m("div", ot, l(e.icon), 1))
                                  ])) : $("", !0),
                                  s("div", rt, [
                                    s("div", ct, l(o(c).getPluginLocalizedName(e)), 1),
                                    s("div", ut, l(e.version), 1)
                                  ]),
                                  s("div", dt, [
                                    p(E, {
                                      color: o(J)(e.status)
                                    }, {
                                      default: d(() => [
                                        _(l(o(Q)(e.status)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color"])
                                  ])
                                ]),
                                s("div", gt, l(o(c).getPluginLocalizedDescription(e)), 1),
                                s("div", pt, l(t.$t("setting.author")) + ": " + l(e.author), 1),
                                e.credits ? (u(), m("div", _t, [
                                  _(l(t.$t("setting.creditsRequired")) + ": ", 1),
                                  s("span", ft, l(e.credits), 1),
                                  _(" " + l(t.$t("setting.credits")), 1)
                                ])) : $("", !0)
                              ]),
                              s("div", mt, [
                                e.status !== "enabled" ? (u(), C(f, {
                                  key: 0,
                                  type: "primary",
                                  onClick: (b) => o(q)(e.id),
                                  class: "plugin-action-btn"
                                }, {
                                  default: d(() => [
                                    _(l(t.$t("setting.enable")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])) : (u(), C(f, {
                                  key: 1,
                                  onClick: (b) => o(z)(e.id),
                                  class: "plugin-action-btn"
                                }, {
                                  default: d(() => [
                                    _(l(t.$t("setting.disable")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])),
                                p(f, {
                                  danger: "",
                                  onClick: (b) => o(W)(e.id),
                                  class: "plugin-action-btn"
                                }, {
                                  default: d(() => [
                                    _(l(t.$t("setting.uninstall")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1024))), 128)),
                        o(L).length === 0 ? (u(), m("div", vt, l(t.$t("setting.noPlugins")), 1)) : $("", !0)
                      ])
                    ]),
                    _: 1
                  }, 8, ["header"]))
                ]),
                _: 1
              }, 8, ["activeKey"])
            ]),
            _: 1
          })
        ]),
        p(S, {
          open: o(h),
          "onUpdate:open": i[2] || (i[2] = (e) => I(h) ? h.value = e : null),
          title: "安装插件",
          width: 600,
          onOk: o(K),
          onCancel: i[3] || (i[3] = (e) => h.value = !1)
        }, {
          default: d(() => [
            s("div", ht, [
              s("div", yt, [
                s("label", Pt, l(t.$t("setting.pluginUrl")), 1),
                p(F, {
                  value: o(P),
                  "onUpdate:value": i[1] || (i[1] = (e) => I(P) ? P.value = e : null),
                  placeholder: "https://example.com/plugin.js",
                  style: { width: "100%" }
                }, null, 8, ["value"])
              ]),
              s("div", kt, l(t.$t("setting.installPluginTips")), 1)
            ])
          ]),
          _: 1
        }, 8, ["open", "onOk"])
      ]);
    };
  }
}), $t = (n, a) => {
  const t = n.__vccOpts || n;
  for (const [i, f] of a)
    t[i] = f;
  return t;
}, Et = /* @__PURE__ */ $t(Ct, [["__scopeId", "data-v-6de15a87"]]);
function Mt() {
  return { component: "PluginUI" };
}
function Rt() {
  return { component: "PluginManager" };
}
function Ut() {
  return { component: "PluginCard" };
}
export {
  Et as Plugin,
  Ut as PluginCard,
  Rt as PluginManager,
  Mt as PluginUI,
  q as activatePlugin,
  z as deactivatePlugin,
  J as getPluginStatusColor,
  Q as getPluginStatusText,
  K as handleInstallPlugin,
  h as installPluginModalVisible,
  H as isImageUrl,
  P as pluginInstallUrl,
  L as pluginsList,
  D as refreshPlugins,
  G as showInstallPluginModal,
  W as uninstallPlugin
};
//# sourceMappingURL=index.mjs.map
